<template>
    <div>
        <resource-form :endpoint="endpoint" :method="method" :rules="rules" :schema="schema" :model="orderModel"
                       :width="900"
                       @closed="$emit('closed')" ref="resourceForm">
            <template #title>{{'app.pages.orders' | trans}}</template>
            <template #button>{{'page.orders.new_individual_order' | trans}}</template>
            <template #form="{ resource }">
                <v-flex xs4 v-if="resource.id">
                    <v-text-field v-model="resource.id"
                                  required
                                  disabled
                                  :label="'app.id' | trans"
                    ></v-text-field>
                </v-flex>
                <v-flex xs4 v-if="typeof resource.id === 'undefined'">
                    <v-text-field v-model="resource.duration"
                                  required
                                  :label="'app.duration' | trans"
                    ></v-text-field>
                </v-flex>
                <v-flex xs4 v-if="typeof resource.id === 'undefined'">
                    <v-select
                            v-model="resource.role_to_assign"
                            :items="rolesToAssign"
                            :label="'app.type' | trans"
                    ></v-select>
                </v-flex>
                <v-flex xs8 v-if="resource.id">
                    <v-select
                            v-model="resource.status"
                            :items="status"
                            :label="'app.status' | trans"
                    ></v-select>
                </v-flex>
                <v-flex xs4>
                    <v-text-field type="number" v-model="resource.amount"
                                  required
                                  :label="'app.amount' | trans"
                    ></v-text-field>
                </v-flex>
                <v-flex xs4 v-if="resource.id && resource.status === 'open'">
                    <v-text-field v-model="resource.estimated_discount"
                                  :label="'app.discount' | trans"
                                  :disabled="true"
                    ></v-text-field>
                </v-flex>
                <v-flex xs4 v-if="resource.id && resource.status !== 'open'">
                    <v-text-field v-model="resource.discount"
                                  :label="'app.discount' | trans"
                    ></v-text-field>
                </v-flex>
                <v-flex xs-4 v-if="resource.id">
                    <v-text-field v-model="resource.with_discount"
                                  :label="'app.with_discount' | trans"
                                  :disabled="true"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="resource.id">
                  <span>{{ 'app.discount_label' | trans }}</span>
                  <template v-if="resource.discount_label && resource.discount_label !== '__DEPRECATED__'">
                    <span>{{ resource.discount_label }}</span>
                  </template>
                  <template v-else>
                    <v-flex xs12>
                      <table class="table">
                        <tr v-for="discount in resource.order_discounts">
                          <td>
                            {{ discount.label }}
                          </td>
                          <td>
                            {{ discount.value | money }}
                          </td>
                        </tr>
                      </table>
                    </v-flex>
                  </template>
                </v-flex>
                <v-flex xs12 v-if="resource.id">
                    <v-text-field v-model="resource.customer_name"
                                  required
                                  :rules="rules.name"
                                  :label="'page.orders.customer_name' | trans"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="resource.id">
                    <v-text-field v-model="resource.customer_street_address"
                                  required
                                  :rules="rules.name"
                                  :label="'page.orders.customer_street_address' | trans"
                    ></v-text-field>
                </v-flex>
                <v-flex xs6 v-if="resource.id">
                    <v-text-field v-model="resource.customer_postal_code"
                                  required
                                  :label="'page.orders.customer_postal_code' | trans"
                    ></v-text-field>
                </v-flex>
                <v-flex xs6 v-if="resource.id">
                    <v-text-field v-model="resource.customer_city"
                                  required
                                  :rules="rules.name"
                                  :label="'page.orders.customer_city' | trans"
                    ></v-text-field>
                </v-flex>
                <v-flex xs6 v-if="resource.id">
                  <v-autocomplete
                      v-model="resource.customer_country"
                      required
                      :rules="rules.country"
                      :label="'page.orders.customer_country' | trans"
                      :items="countries"
                      item-text="name"
                      item-value="code"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs6 v-if="resource.id">
                    <v-text-field v-model="resource.customer_NIP"
                                  required
                                  :label="'page.orders.customer_nip' | trans"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="resource.id && resource.subscription_type_id !== 30">
                    <v-select
                            v-model="resource.subscription_type_id"
                            :items="subscriptionTypes"
                            solo
                            :label="'app.subscription' | trans"
                    ></v-select>
                </v-flex>
                <v-flex xs10 v-if="resource.subscription_type_id === 30">
                  <v-layout align-center justify-center row fill-height>
                    <v-label>{{getIndividualOrderURL()}}</v-label>
                  </v-layout>
                </v-flex>
                <v-flex xs2 v-if="resource.subscription_type_id === 30">
                  <v-btn color="success" @click="copyLink">Kopiuj</v-btn>
                </v-flex>
                <v-flex v-if="resource.subscription_type_role_to_assign === 'dietitian_student' && !resource.student_status_verified"
                        xs4 v-for="file in resource.student_status_verification_files" :key="file">
                    <expandable-image :src="file"/>
                </v-flex>
                <v-flex v-if="resource.student_status_verified">
                  <v-label>{{ `app.student_status_verified`|trans}}</v-label>
                </v-flex>
            </template>
            <template #action="{ resource }">
                <v-btn v-if="resource.subscription_type_role_to_assign === 'dietitian_student'
                && !resource.student_status_verified
                && resource.status === 'open'"
                       color="cancel" flat @click="confirmStudentStatus">
                    {{ 'app.confirm' | trans }}
                </v-btn>
            </template>
        </resource-form>
    </div>
</template>

<script>
  import has from 'lodash/has';
  import { trans } from '../../../app';
  import { mapState, mapGetters } from 'vuex';

  export default {

    props: {
      model: Object,
    },
    data: () => ({
      orderModel: null,
      schema: {
        name: null,
        roles: [],
      },
      subscriptions: [],
      nameError: [],
      rules: {
        name: [
          v => !!v || trans('validation.required', { 'attribute': trans('app.name') }),
          v => v && v.length <= 255 || trans('validation.max.string', {
            attribute: trans('app.name'),
            max: 255,
          }),
          v => v && v.length >= 3 || trans('validation.min.string', {
            attribute: trans('app.name'),
            min: 3,
          }),
        ],
      },
    }),
    watch: {
      model (val) {
        this.orderModel = val;
      },
    },

    computed: {
      ...mapGetters(['countries']),
      ...mapState(['dictionaries']),
      status () {
        return [
          { text: trans('page.orders.open'), value: 'open' },
          { text: trans('page.orders.canceled'), value: 'canceled' },
          { text: trans('page.orders.closed'), value: 'closed' },
          { text: trans('page.orders.pending'), value: 'pending' },
          { text: trans('page.orders.rejected'), value: 'rejected' },
        ];
      },
      rolesToAssign() {
        return [
            { text: trans('page.roles.dietitian_student'), value: 'dietitian_student'},
            { text: trans('page.roles.dietitian_standard'), value: 'dietitian_standard'},
            { text: trans('page.roles.dietitian_premium'), value: 'dietitian_premium'},
        ];
      },
      method () {
        return has(this.model, 'id') ? 'PATCH' : 'POST';
      },
      endpoint () {
        if (has(this.model, 'id')) {
          return `/administrator/orders/${this.model.uuid}`;
        }

        return '/administrator/orders';
      },
      subscriptionTypes () {
        return this.dictionaries.subscriptions.filter(({id}) => id !== 30).map(({ id, name, duration, price }) => ({
          text: name + ' (' + duration + ' dni - ' + price + ' zł)',
          value: id,
        }));
      }
    },
    methods: {
      async confirmStudentStatus() {
        this.loading = true;

        try {
          let resource = this.$refs.resourceForm.resource;
          resource.student_status_verified = true;

          const response = await axios({
            url: this.endpoint,
            method: this.method,
            data: resource
          });

          this.$root.$emit('stored', {
            type: this.$refs.resourceForm.resource,
            response,
          });

          this.$toast(trans('app.saved'));
          this.$refs.resourceForm.close();
        } catch (error) {
          if (error.response && error.response.status === 422) {
            this.errors.record(error.response.data.errors);
          } else {
            this.sentryCaptureException(error);
          }
        }
        this.loading = false;
      },
      getIndividualOrderURL() {
        return this.model ? `${document.location.origin}/orders/individual/${this.model.uuid}` : '';
      },
      copyLink() {
        navigator.clipboard.writeText(this.getIndividualOrderURL());
      }
    }
  };
</script>
